<template lang="pug">
.whatis
  .container
    h2 CDP 是什么？
    p CDP （Content Distribution Platform）即内容分配平台，可服务于接入多家 CDN 厂商的用户，实现了按比例灵活调配各 CDN 厂商在不同地区不同运营商中的流量带宽；并能自动收集、监测各 CDN 厂商的节点信息，相互融合，在让域名享受全网都有本地节点覆盖的同时，自动剔除故障节点，保障业务的正常服务。
</template>

<script>
export default {
  name: 'whatis'
}
</script>

<style lang="sass" scoped>
h2
  color: #333333
  text-align: center
  margin-bottom: 40px

.whatis
  position: relative
  padding: 98px 0
  background-color: #fafafa
  &::before
    content: ''
    position: absolute
    top: -24px
    left: 0
    right: 0
    margin: auto
    width: 48px
    height: 48px
    background: url('../assets/down.svg') no-repeat

.container
  width: 1120px
  margin: 0 auto

p
  color: #666666

</style>



// WEBPACK FOOTER //
// whatis.vue?244f0712